/**
 * Telegram founder-bot configuration API client (Phase 11 / M9).
 *
 * The settings UI uses these wrappers to test / register / disconnect
 * the bot. The actual token never lives in the gateway — it is
 * forwarded to chaos-openclaw-bridge which persists it via Infisical.
 */
import { apiJson } from './client';

export interface TelegramStatus {
  configured: boolean;
  webhookMode: boolean;
  webhookUrl: string | null;
  botUsername: string | null;
  botId: number | null;
  founderUserIds: number[];
  error: string | null;
  message?: string;
}

export interface TestConnectionResult {
  ok: boolean;
  botUsername?: string | null;
  botId?: number | null;
  botFirstName?: string | null;
  message?: string | null;
}

export interface RegisterWebhookResult {
  ok: boolean;
  webhookUrl: string;
  secret: string;
  botUsername?: string | null;
  message?: string | null;
}

export interface DisconnectResult {
  ok: boolean;
  message?: string | null;
}

export const telegramKeys = {
  status: () => ['telegram', 'status'] as const,
} satisfies Record<string, (...args: never[]) => readonly unknown[]>;

export const telegramApi = {
  status: () => apiJson<TelegramStatus>('/telegram/status'),
  testConnection: (botToken: string) =>
    apiJson<TestConnectionResult>('/telegram/test-connection', {
      method: 'POST',
      json: { botToken },
    }),
  registerWebhook: (input: { botToken: string; founderUserId: string; webhookSecret?: string }) =>
    apiJson<RegisterWebhookResult>('/telegram/register-webhook', {
      method: 'POST',
      json: input,
    }),
  disconnect: () => apiJson<DisconnectResult>('/telegram/disconnect', { method: 'POST' }),
};
